export const OUTGOING_PATH = '/app/mailbox/outgoing';
export const MAILBOX_SETTINGS_PATH = '/app/settings/mailbox';

/** The bulk draft page, where the agent checks a bulk draft's emails and sends them. */
export const bulkDraftPath = (bulkSendId: string) => `${OUTGOING_PATH}/bulk/${bulkSendId}`;
